import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTablesModule } from 'angular-datatables/src/angular-datatables.module';
import { MaskApplierService } from 'ngx-mask';
import { Config } from 'protractor';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { InstanceModel } from 'src/app/model/instance.model';
import { InstanceService } from 'src/app/service/instance.service';
import { CurrencyService } from 'src/app/service/currency.service';
import { CreateInstanceModel } from 'src/app/model/create-instance.model';
import swal from "sweetalert2";
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { AuthenticationService } from 'src/app/service/auth.service';

declare var $: any;

@Component({
  selector: "app-grid",
  templateUrl: "./grid.component.html",
  styleUrls: ["./grid.component.scss"],
})
export class GridComponent extends ComponentBase implements OnInit {
  Config = DataTablesModule;

  dtOptions: Config = {};

  @ViewChild("prorrogacaoBoletoModal") prorrogacaoBoletoModal: any;
  @ViewChild("abatimentoBoletoModal") abatimentoBoletoModal: any;
  @ViewChild("baixaBoletoModal") baixaBoletoModal: any;

  documento: string;
  valor: number;
  dataVencimento: string;
  venda: string;
  compradorId: string;
  vendedorId: string;
  chaveDanfe: string;
  identificador: string;
  selectedItem: AttributeModel;
  history: AttributeModel;

  constructor(
    private instanceService: InstanceService,
    private authService: AuthenticationService,
    maskService: MaskApplierService
  ) {
    super(maskService);
  }

  items: AttributeModel[] = [];
  itemKey: string;
  itemTitle: string;
  itemsTitles: string[] = [];

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 5,
      columnDefs: [
        {
          orderable: false,
          targets: [-1] // Targets the last column
        },
      ],
      responsive: true,
      dom: '<"row"<"col-sm-6"l><"col-sm-6"f>>rtip', // This puts length and filter on same row
      searching: true, // Explicitly enable searching
      lengthMenu: [
        [5, 10, 25, 50, -1],
        ["5", "10", "25", "50", "Todas"],
      ],
      language: {
        url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json",
      },
    };

    let itemsAttr = this.attribute.attributes.find(
      (attr) => attr.type.toLowerCase() == "items"
    );

    if (!itemsAttr) {
      itemsAttr = {
        key: "items",
        type: "items",
      };
      this.attribute.attributes.push(itemsAttr);
    }

    this.itemKey = itemsAttr.key;

    this.items = itemsAttr.attributes;

    this.getItemTitleRecursive(this.items[0], this.itemsTitles);

    this.itemsTitles.shift();
  }

  getCurrencyMask(): string {
    return "0,00||00,00||000,00||0.000,00||00.000,00||000.000,00||0.000.000,00||00.000.000,00||000.000.000,00||0.000.000.000,00||00.000.000.000,00||000.000.000.000,00";
  }

  private getItemTitleRecursive(
    item: AttributeModel,
    titles: string[],
    depth: number = 0
  ) {
    if (item) {
      const canView = !item.options.some(
        (opt) =>
          opt.key.toLowerCase() == "viewmode" &&
          opt.value.toLowerCase() == "hidden"
      );

      if (canView) {
        titles.push(`${this.getItemKey(item)}`);
      }

      if (depth <= 2) {
        depth++;

        item.attributes.forEach((childItem) =>
          this.getItemTitleRecursive(childItem, titles, depth)
        );
      }
    }
  }

  private getItemKey(item: AttributeModel) {
    var titleOpt = item.options.find((opt) => opt.key.toLowerCase() == "title");

    if (titleOpt) {
      return titleOpt.value;
    }

    return item.key;
  }

  getItemValue(item: AttributeModel): string {
    const maskOpt = item.options.find((opt) => opt.key.toLowerCase() == "mask");

    if (maskOpt) {
      let maskPattern = "";

      if (maskOpt.value.toLowerCase() == "currency") {
        maskPattern = this.getCurrencyMaskText(item);
      } else {
        maskPattern = maskOpt.value;
      }

      return this.applyPrefix(
        this.maskService.applyMask(item.value, maskPattern),
        maskOpt
      );
    }

    return item.value;
  }

  private applyPrefix(value: string, maskOpt: OptionModel): string {
    if (maskOpt && maskOpt.value.toLowerCase() == "currency") {
      return `R$ ${value}`;
    }

    return "";
  }

  getItemTitle(item: AttributeModel): string {
    if (item.options) {
      let titleOpt = item.options.find(
        (opt) => opt.key.toLowerCase() == "title"
      );

      if (titleOpt) {
        return titleOpt.value;
      }
    }

    return this.attribute.key;
  }

  getVisibleAttributes(item: AttributeModel): AttributeModel[] {
    return item.attributes.filter(
      (attr) =>
        !attr.options.some(
          (opt) =>
            opt.key.toLowerCase() == "viewmode" &&
            opt.value.toLowerCase() == "hidden"
        )
    );
  }

  hasPermission(item: AttributeModel, columnItem: AttributeModel): boolean {
    if (this.isLink(columnItem)) {
      const statusAttr = item.attributes.find(
        (attr) => attr.key.toLowerCase() == "status boleto"
      );

      if (statusAttr?.value.toLowerCase() == "liquidado" || 
          this.authService.hasRole("Representante comercial")) {
        return false;
      }
    }

    return true;
  }

  canPrint(item: AttributeModel, columnItem: AttributeModel): boolean {
    if (this.isLink(columnItem)) {
      const statusAttr = item.attributes.find(
        (attr) => attr.key.toLowerCase() == "status boleto"
      );

      if (statusAttr?.value.toLowerCase() == "em cartório") {
        return false;
      }
    }

    return true;
  }

  isLink(item: AttributeModel): boolean {
    return item.type.toLowerCase() == "link";
  }

  onClick(item: AttributeModel) {
    let targetOpt = item.options.find(
      (opt) => opt.key.toLowerCase() == "target"
    );

    let targetValue: string;
    let targetType = "_blank";

    const targetTypeOpt = item.options.find(
      (opt) => opt.key.toLowerCase() == "targetType".toLowerCase()
    );

    if (targetTypeOpt) {
      if (!targetTypeOpt.value.startsWith("_")) {
        targetType = `_${targetTypeOpt.value}`;
      } else {
        targetType = targetTypeOpt.value;
      }
    }

    if (targetOpt) {
      targetValue = targetOpt.value;
    } else {
      targetValue = item.value;
    }

    if (targetValue.startsWith("http")) {
      window.open(targetValue, targetType);
    } else {
      this.emit({ name: "turn", data: targetValue });
    }
  }

  onInputChangeValorAbatimento(event: any) {
    let inputElement = event.target;
    let start = inputElement.selectionStart;
    let end = inputElement.selectionEnd;

    if (start === end) {
      const newPosition = start + 1;
      setTimeout(() => {
        inputElement.setSelectionRange(newPosition, newPosition);
      }, 10);
    }
  }

  openProrrogacaoBoletoModal(item: AttributeModel) {
    const documentAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "documento"
    );
    const valueAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "valor"
    );
    const dueDateAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vencimento"
    );
    this.documento = documentAttr ? documentAttr.value : null;
    this.valor = valueAttr ? Number(valueAttr.value) : null;
    const [day, month, year] = dueDateAttr.value.split("/");
    this.dataVencimento = dueDateAttr ? `${year}-${month}-${day}` : null;
    this.selectedItem = item;
  }

  openAbatimentoBoletoModal(item: AttributeModel) {
    const documentAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "documento"
    );
    const valueAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "valor"
    );
    const dueDateAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vencimento"
    );
    this.documento = documentAttr ? documentAttr.value : null;
    this.valor = valueAttr ? Number(valueAttr.value) : null;
    const [day, month, year] = dueDateAttr.value.split("/");
    this.dataVencimento = dueDateAttr ? `${year}-${month}-${day}` : null;
    this.selectedItem = item;
  }

  openBaixaBoletoModal(item: AttributeModel) {
    const documentAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "documento"
    );
    const valueAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "valor"
    );
    const dueDateAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vencimento"
    );
    this.documento = documentAttr ? documentAttr.value : null;
    this.valor = valueAttr ? Number(valueAttr.value) : null;
    const [day, month, year] = dueDateAttr.value.split("/");
    this.dataVencimento = dueDateAttr ? `${year}-${month}-${day}` : null;
    this.selectedItem = item;
  }

  openHistoricoBoletoModal(item: AttributeModel) {
    const documentAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "documento"
    );
    this.documento = documentAttr ? documentAttr.value : null;
    const historyAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "history"
    );

    this.history = historyAttr ? historyAttr : null;

    this.selectedItem = item;

    $("#historicoBoletoModal").modal("show");
  }

  hasHistory(item: AttributeModel): boolean {
    const historyAttr = item.attributes.find(
      (attr) => attr.key.toLowerCase() == "history"
    );

    return !!historyAttr.attributes.length;
  }

  formatarHistorico(history: AttributeModel): string[] {
    // Extrai os atributos relevantes
    const historico = history.attributes.map((attr) => {
      const key = attr.key;
      const status = attr.attributes.find(
        (attr) =>
          attr.key.toLowerCase() == "status" ||
          attr.key.toLowerCase() == "data liquidação"
      );

      const data = attr.attributes.find(
        (attr) => attr.key.toLowerCase() == "creation date"
      );

      let creationDate = data ? data.value : null;

      if (creationDate) {
        const dateParts = creationDate.split(" ")[0].split("-"); // Supondo que a data esteja no formato "yyyy-MM-dd"
        const dateObj = new Date(`${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`);
        dateObj.setDate(dateObj.getDate() + 1); // Adiciona um dia
        const formattedDate = dateObj.toLocaleDateString("pt-BR");
        creationDate = formattedDate;
      }

      let value = status ? status.value : null;

      // Se for "data liquidação", formata a data no padrão pt-BR
      if (status && status.key.toLowerCase() === "data liquidação" && value) {
        const dateParts = value.split(" ")[0].split("-"); // Supondo que a data esteja no formato "yyyy-MM-dd"
        const formattedDate = new Date(
          `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`
        ).toLocaleDateString("pt-BR");
        value = formattedDate;
      } else {
        value = status ? creationDate + " - " + status.value : null;
      }

      // Formatar cada linha do histórico como "key: value"
      return `${key}: ${value}`;
    });

    return historico;
  }

  onProrrogarBoleto(
    $novoVencimento: number,
    $motivo: string,
    $item: AttributeModel
  ) {
    const vendaAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "venda"
    );
    this.venda = vendaAttr ? vendaAttr.value : null;

    const compradorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "comprador id"
    );
    this.compradorId = compradorIdAttr ? compradorIdAttr.value : null;

    const vendedorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vendedor id"
    );
    this.vendedorId = vendedorIdAttr ? vendedorIdAttr.value : null;

    const chaveDanfeAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "chave danfe"
    );
    this.chaveDanfe = chaveDanfeAttr ? chaveDanfeAttr.value : null;

    const identificadorAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "identificador externo"
    );

    const policyIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "policy id prorrogação"
    );

    this.identificador = identificadorAttr ? identificadorAttr.value : null;
    let instancia = new CreateInstanceModel();
    instancia.policyId = policyIdAttr?.value;
    instancia.attributes = [
      {
        key: "Identificador Externo",
        value: this.identificador,
        type: "Text",
      },
      {
        key: "Venda",
        value: this.venda,
        type: "Text",
      },
      {
        key: "Comprador",
        value: this.compradorId,
        type: "Text",
      },
      {
        key: "Vendedor",
        value: this.vendedorId,
        type: "Text",
      },
      {
        key: "Chave Danfe",
        value: this.chaveDanfe,
        type: "Text",
      },
      {
        key: "Documento",
        value: this.documento,
        type: "Text",
      },
      {
        key: "Vencimento",
        value: this.dataVencimento,
        type: "DateTime",
      },
      {
        key: "Valor do boleto",
        value: this.currencyService.getCurrencyStringAsNumberNormalized(this.valor.toString()),
        type: "Text",
      },
      {
        key: "Nova data de vencimento",
        value: $novoVencimento.toString(),
        type: "Text",
      },
      {
        key: "Motivo",
        value: $motivo,
        type: "Text",
      },
    ];

    try {
      this.instanceService.save(instancia).subscribe();
      swal.fire({
        title: "Successo",
        text: "Solicitação de prorrogação enviada com sucesso.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao enviar solicitação de prorrogação.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    this.closeModal("prorrogacaoBoletoModal");
  }

  onAbaterBoleto($novoValor: number, $motivo: string, $item: AttributeModel) {
    const vendaAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "venda"
    );
    this.venda = vendaAttr ? vendaAttr.value : null;

    const compradorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "comprador id"
    );
    this.compradorId = compradorIdAttr ? compradorIdAttr.value : null;

    const vendedorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vendedor id"
    );
    this.vendedorId = vendedorIdAttr ? vendedorIdAttr.value : null;

    const chaveDanfeAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "chave danfe"
    );
    this.chaveDanfe = chaveDanfeAttr ? chaveDanfeAttr.value : null;

    const Identificador = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "identificador externo"
    );

    const policyIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "policy id abatimento"
    );

    this.identificador = Identificador ? Identificador.value : null;
    let instancia = new CreateInstanceModel();
    instancia.policyId = policyIdAttr?.value;
    instancia.attributes = [
      {
        key: "Identificador Externo",
        value: this.identificador,
        type: "Text",
      },
      {
        key: "Venda",
        value: this.venda,
        type: "Text",
      },
      {
        key: "Comprador",
        value: this.compradorId,
        type: "Text",
      },
      {
        key: "Vendedor",
        value: this.vendedorId,
        type: "Text",
      },
      {
        key: "Chave Danfe",
        value: this.chaveDanfe,
        type: "Text",
      },
      {
        key: "Documento",
        value: this.documento,
        type: "Text",
      },
      {
        key: "Vencimento",
        value: this.dataVencimento,
        type: "Date",
      },
      {
        key: "Valor do boleto",
        value: this.currencyService.getCurrencyStringAsNumberNormalized(this.valor.toString()),
        type: "Text",
      },
      {
        key: "Valor do abatimento",
        value: $novoValor.toString(),
        type: "Text",
      },
      {
        key: "Motivo",
        value: $motivo,
        type: "Text",
      },
    ];

    try {
      this.instanceService.save(instancia).subscribe();
      swal.fire({
        title: "Successo",
        text: "Solicitação de abatimento enviada com sucesso.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao enviar solicitação de abatimento.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    this.closeModal("abatimentoBoletoModal");
  }

  onBaixarBoleto($motivo: string, $item: AttributeModel) {
    const vendaAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "venda"
    );
    this.venda = vendaAttr ? vendaAttr.value : null;

    const compradorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "comprador id"
    );
    this.compradorId = compradorIdAttr ? compradorIdAttr.value : null;

    const vendedorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vendedor id"
    );
    this.vendedorId = vendedorIdAttr ? vendedorIdAttr.value : null;

    const chaveDanfeAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "chave danfe"
    );
    this.chaveDanfe = chaveDanfeAttr ? chaveDanfeAttr.value : null;

    const identificadorAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "identificador externo"
    );

    const policyIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "policy id baixa"
    );

    this.identificador = identificadorAttr ? identificadorAttr.value : null;
    let instancia = new CreateInstanceModel();
    instancia.policyId = policyIdAttr?.value;
    instancia.attributes = [
      {
        key: "Identificador Externo",
        value: this.identificador,
        type: "Text",
      },
      {
        key: "Venda",
        value: this.venda,
        type: "Text",
      },
      {
        key: "Comprador",
        value: this.compradorId,
        type: "Text",
      },
      {
        key: "Vendedor",
        value: this.vendedorId,
        type: "Text",
      },
      {
        key: "Chave Danfe",
        value: this.chaveDanfe,
        type: "Text",
      },
      {
        key: "Documento",
        value: this.documento,
        type: "Text",
      },
      {
        key: "Vencimento",
        value: this.dataVencimento,
        type: "Date",
      },
      {
        key: "Valor do boleto",
        value: this.currencyService.getCurrencyStringAsNumberNormalized(this.valor.toString()),
        type: "Text",
      },
      {
        key: "Motivo",
        value: $motivo,
        type: "Text",
      },
    ];

    try {
      this.instanceService.save(instancia).subscribe();
      swal.fire({
        title: "Successo",
        text: "Solicitação de baixa enviada com sucesso.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao enviar solicitação de baixa.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    this.closeModal("baixaBoletoModal");
  }

  closeModal(modalId: string) {
    $("#" + modalId).modal("hide"); // Fecha o modal
  }
}
